export default "__VITE_ASSET__b76083f5__"